import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { heroContent } from '../mock';
import { Button } from './ui/button';
import { useSiteContent } from '../contexts/SiteContentContext';

const isVideoUrl = (url) => {
  if (!url) return false;
  const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov'];
  const lowerUrl = url.split('?')[0].toLowerCase();
  return videoExtensions.some(ext => lowerUrl.endsWith(ext));
};

export const HeroSection = () => {
  const content = useSiteContent();
  const navigate = useNavigate();
  const scrollToSection = (section) => {
    const element = document.querySelector(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const mediaUrl = content?.heroMediaUrl || heroContent.videoUrl;
  const isVideo = isVideoUrl(mediaUrl);

  return (
    <section id="accueil" className="relative h-screen w-full overflow-hidden">
      {/* Background Media */}
      <div className="absolute inset-0 z-0">
        {isVideo ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          >
            <source src={mediaUrl} type="video/mp4" />
          </video>
        ) : (
          <img
            src={mediaUrl}
            alt="Hero background"
            className="w-full h-full object-cover"
          />
        )}
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-[#FF1B6D] mb-6 tracking-tight">
            {content?.heroTitle || heroContent.title}
          </h1>
          <p className="text-xl sm:text-2xl md:text-3xl text-white/90 mb-12 font-light tracking-wide">
            {content?.heroSubtitle || heroContent.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <Button
              onClick={() => scrollToSection('#evenements')}
              className="bg-[#FF1B6D] hover:bg-[#E01660] text-white font-bold text-base sm:text-lg px-8 py-6 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl hover:shadow-[#FF1B6D]/50"
            >
              {content?.heroPrimaryCTA || heroContent.primaryCTA}
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button
              onClick={() => navigate('/videos')}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base sm:text-lg px-8 py-6 rounded-full transition-all duration-300 transform hover:scale-105"
            >
              <Play className="mr-2" size={20} />
              {content?.heroSecondaryCTA || heroContent.secondaryCTA}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};